import { SelectOption } from '@fleet-beat/core';

export enum AssistantRecommendedActionEnum {
  STOP_IMMEDIATELY = 'STOP_IMMEDIATELY',
  PROCEED_WITH_CAUTION = 'PROCEED_WITH_CAUTION',
  REPORT_ON_ARRIVAL = 'REPORT_ON_ARRIVAL',
  SEEK_SERVICE = 'SEEK_SERVICE',
}

export const AssistantRecommendedActionOptions: SelectOption[] = [
  { value: AssistantRecommendedActionEnum.STOP_IMMEDIATELY, label: 'Stop Immediately' },
  { value: AssistantRecommendedActionEnum.PROCEED_WITH_CAUTION, label: 'Proceed with Caution' },
  { value: AssistantRecommendedActionEnum.REPORT_ON_ARRIVAL, label: 'Report on Arrival' },
  { value: AssistantRecommendedActionEnum.SEEK_SERVICE, label: 'Seek Service' },
];

export enum AssistantIncidentSeverityEnum {
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export const AssistantIncidentSeverityOptions: SelectOption[] = [
  { value: AssistantIncidentSeverityEnum.LOW, label: 'Low' },
  { value: AssistantIncidentSeverityEnum.MODERATE, label: 'Moderate' },
  { value: AssistantIncidentSeverityEnum.HIGH, label: 'High' },
  { value: AssistantIncidentSeverityEnum.CRITICAL, label: 'Critical' },
];
